import { Button } from 'components/ui/button';
import { useSidebar } from 'components/ui/sidebar';
import { usePageHeaderValue } from 'contexts/page-header';
import { ArrowLeft, Menu } from 'lucide-react';
import React from 'react';
import { useHistory } from 'react-router-dom';

// Replaces the fixed sidebar under the `md` breakpoint: a 52px bar with the
// navigation drawer trigger, the page title (or the logo), and page actions.
// Hidden with CSS at md+ so there is no layout flash while `useIsMobile`
// settles.
export function MobileAppBar () {
  const { toggleSidebar } = useSidebar();
  const history = useHistory();
  const { title, subtitle, actions, back, onBack } = usePageHeaderValue();

  return (
    <header className="flex h-[52px] shrink-0 items-center gap-1.5 border-b border-sidebar-border bg-sidebar px-1.5 md:hidden">
      {back ? (
        <Button
          variant="ghost"
          size="icon"
          className="h-10 w-10 shrink-0 text-sidebar-foreground"
          onClick={onBack ?? (() => history.goBack())}
          aria-label="Back"
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
      ) : (
        <Button
          variant="ghost"
          size="icon"
          className="h-10 w-10 shrink-0 text-sidebar-foreground"
          onClick={toggleSidebar}
          aria-label="Open navigation"
        >
          <Menu className="h-5 w-5" />
        </Button>
      )}
      {title ? (
        <div className="flex min-w-0 flex-1 flex-col justify-center">
          <div className="truncate text-sm font-bold leading-tight">{title}</div>
          {subtitle && <div className="truncate text-[11px] leading-tight text-muted-foreground">{subtitle}</div>}
        </div>
      ) : (
        <div className="flex min-w-0 flex-1 items-center">
          <img src="/assets/hilo-full-logo.png" alt="HiLo Analytics" className="h-[22px] object-contain" />
        </div>
      )}
      {actions && <div className="flex shrink-0 items-center gap-0.5">{actions}</div>}
    </header>
  );
}
